import React, { Fragment } from "react"
import { Link } from "react-router-dom"

import classes from "./Breadcrumb.module.scss"

const Breadcrumb = props => {
  const { title } = props
  const items = Array.isArray(props.items) ? props.items : title ? [{ name: title }] : []

  return (
    <div className={classes["container"]}>
      <Link to="/">خانه</Link>
      <span>/</span>
      {items.map((item, i) =>
        items.length - 1 !== i ?
          <Fragment key={i}>
            <Link to={item.url}>
              <span className={classes["item"]}>
                {item.name}
              </span>
            </Link>
            <span>/</span>
          </Fragment>
          :
          <span key={i} className={classes["item"]}>
            {item.name}
          </span>
      )}
    </div>
  )
}

export default Breadcrumb
